const Story = ({prm}) => {
  return ( 
    <div>
        <div className="story-des">{prm.description}</div> 
        <div className="story">
          <span><img src="/images/location.svg" alt={prm.name} /> </span>
          <span>{prm.name}</span>
        </div>
    </div> 
    );
}

export default Story